import axios from 'axios';
import AppPopupLike from '../../components/AppPopupLike.vue';
import store from '../../store';
import {Popup} from '../popup';
import TopMessageHandler from './../../library/topMessageHandler';
import Loader from './loader';

export const STATUS_ALL     = 0;
export const STATUS_LIKE    = 1;
export const STATUS_DISLIKE = -1;
export const STATUS_NONE    = null;

const likeInstances: LikeHandlerInstances = {};

export default class LikeHandler
{
    private readonly instanceName: string;

    private options: LikeHandlerOptions;

    static get instances(): LikeHandlerInstances
    {
        return likeInstances;
    }

    constructor(instanceName: string, options: LikeHandlerOptions)
    {
        this.instanceName = instanceName;
        this.options      = options;

        likeInstances[instanceName] = this;
    }

    destroy()
    {
        delete likeInstances[this.instanceName];
    }

    _like(status: LikeStatus, data = {}, obj: Nullable<{}> = null): Promise<any>
    {
        let currentUser: CurrentUser = store.state.layoutData.user;

        if (currentUser.isMultiLogin)
        {
            return Promise.resolve();
        }

        Loader.show();

       return axios.post(this.options.likeAction, Object.assign({}, data, {'like-status': status})).then((response) =>
        {
            if (obj === null)
            {
                return;
            }

            let data      = response.data.data;
            let newStatus = 0;
            let likeData  = obj[this.options.objectName];
            if(typeof likeData === 'undefined' || Array.isArray(likeData))
            {
                obj[this.options.objectName] = Object.assign({
                    like: 0,
                    dislike: 0,
                    status: 0,
                });

            }

            likeData = obj[this.options.objectName];

            for (let key in data.change)
            {
                if(data.change.hasOwnProperty(key))
                {
                    let status  = parseInt(key);
                    let value   = data.change[key];
                    let keyName = status === STATUS_LIKE ? 'like' : 'dislike';

                    // new like/dislike status
                    if(value === 1)
                    {
                        newStatus = status;
                    }

                    likeData[keyName] += value;
                }
            }

            likeData.status = newStatus;
        })
        .catch(() => TopMessageHandler.error('Es ist ein Fehler aufgetreten, bitte versuchen Sie es später erneut.'))
        .then(() => Loader.hide());
    }

    like(data = {}, obj: Nullable<{}> = null): Promise<any>
    {
        return this._like(STATUS_LIKE, data, obj);
    }

    dislike(data = {}, obj: Nullable<{}> = null): Promise<any>
    {
        return this._like(STATUS_DISLIKE, data, obj);
    }

    openUsers(data = {})
    {
        if(!this.options.getUsersAction)
        {
            return;
        }

        Loader.show();
        axios.post(this.options.getUsersAction, data || {}).then((response) =>
        {
            let data  = response.data.data;
            let popup = new Popup({
                title: data.title || '',
                component: AppPopupLike,
                componentProps: data,
            });
            popup.open();
        })
        .catch(() => TopMessageHandler.error('Es ist ein Fehler aufgetreten, bitte versuchen Sie es später erneut.'))
        .finally(() => Loader.hide());
    }
}